import { z } from 'zod';

export const crowdexSubagentDataSchema = z.object({
  toolCallId: z.string(),
  title: z.string(),
  agentType: z.string().nullable(),
  prompt: z.string().nullable(),
  status: z.enum(['pending', 'in_progress', 'completed', 'failed', 'cancelled']),
  transcript: z.string(),
  thought: z.string(),
  /**
   * The child's own session: a backend's native one, or, with `revision`, the Crowdex
   * conversation a Crowdex subagent is (a child conversation of the one that spawned it).
   */
  threadId: z.string().nullable(),
  /**
   * Set by Crowdex delegation only: which message of its child conversation this is (one per
   * message the parent sent it, from 1). Its conversation is `threadId`.
   */
  revision: z.number().int().positive().optional(),
  path: z.string().nullable(),
  activity: z.string().nullable(),
  tools: z
    .array(
      z.object({
        toolCallId: z.string(),
        title: z.string(),
        kind: z
          .enum([
            'read',
            'edit',
            'delete',
            'move',
            'search',
            'execute',
            'think',
            'fetch',
            'switch_mode',
            'other',
          ])
          .nullable(),
        status: z.enum(['pending', 'in_progress', 'completed', 'failed', 'cancelled']),
        input: z.json(),
        output: z.json().nullable(),
      }),
    )
    .default([]),
});
